import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class ApplicationRoute extends Route {
  @service intl;
  @service localeManager;
  @service session;
  @service currentUser;
  @service launchdarkly;

  async _loadCurrentUser() {
    try {
      await this.currentUser.load();
    } catch {
      await this.session.invalidate();
    }
  }

  async beforeModel() {
    await this.session.setup();
    await this._loadCurrentUser();

    let locale = this.localeManager.negotiateLocale(this.currentUser.user?.locale);
    await this.localeManager.loadAndSetLocale(locale);
    this.intl.setOnMissingTranslation(this.intl.onMissingTranslation);

    if (!this.launchdarkly.isInitialized) {
      await this.launchdarkly.setup();
    }

    await this.launchdarkly.setup();
  }
}
